export default __webpack_public_path__ + "images/91817b73188d33529563e6029625f7ea-icon-logo-douleutaras-round.svg";